/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadExternalEhrPatient
 */
export interface PalAuthSubmissionLeadExternalEhrPatient {
    /**
     * 
     */
    patient_id?: string;
    /**
     * 
     */
    type?: PalAuthSubmissionLeadExternalEhrPatientTypeEnum;
    /**
     * 
     */
    details_push_date?: string;
    /**
     * 
     */
    details_extraction_date?: string;
    /**
     * 
     */
    is_extracting_details?: boolean;
    /**
     * 
     */
    is_screener_document_upload_in_progress?: boolean;
    /**
     * 
     */
    is_additional_document_upload_in_progress?: boolean;
    /**
     * 
     */
    is_generated_document_upload_in_progress?: boolean;
}


/**
 * @export
 */
export const PalAuthSubmissionLeadExternalEhrPatientTypeEnum = {
    Pcc: 'PCC',
    MatrixCare: 'MATRIX_CARE',
    Hchb: 'HCHB',
    MatrixCareHomeHealth: 'MATRIX_CARE_HOME_HEALTH',
} as const;
export type PalAuthSubmissionLeadExternalEhrPatientTypeEnum = typeof PalAuthSubmissionLeadExternalEhrPatientTypeEnum[keyof typeof PalAuthSubmissionLeadExternalEhrPatientTypeEnum];


/**
 * Check if a given object implements the PalAuthSubmissionLeadExternalEhrPatient interface.
 */
export function instanceOfPalAuthSubmissionLeadExternalEhrPatient(value: object): value is PalAuthSubmissionLeadExternalEhrPatient {
    return true;
}

export function PalAuthSubmissionLeadExternalEhrPatientFromJSON(json: any): PalAuthSubmissionLeadExternalEhrPatient {
    return PalAuthSubmissionLeadExternalEhrPatientFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadExternalEhrPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadExternalEhrPatient {
    if (json == null) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'] == null ? undefined : json['patient_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'details_push_date': json['details_push_date'] == null ? undefined : json['details_push_date'],
        'details_extraction_date': json['details_extraction_date'] == null ? undefined : json['details_extraction_date'],
        'is_extracting_details': json['is_extracting_details'] == null ? undefined : json['is_extracting_details'],
        'is_screener_document_upload_in_progress': json['is_screener_document_upload_in_progress'] == null ? undefined : json['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': json['is_additional_document_upload_in_progress'] == null ? undefined : json['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': json['is_generated_document_upload_in_progress'] == null ? undefined : json['is_generated_document_upload_in_progress'],
    };
}

export function PalAuthSubmissionLeadExternalEhrPatientToJSON(json: any): PalAuthSubmissionLeadExternalEhrPatient {
    return PalAuthSubmissionLeadExternalEhrPatientToJSONTyped(json, false);
}

export function PalAuthSubmissionLeadExternalEhrPatientToJSONTyped(value?: PalAuthSubmissionLeadExternalEhrPatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient_id': value['patient_id'],
        'type': value['type'],
        'details_push_date': value['details_push_date'],
        'details_extraction_date': value['details_extraction_date'],
        'is_extracting_details': value['is_extracting_details'],
        'is_screener_document_upload_in_progress': value['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': value['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': value['is_generated_document_upload_in_progress'],
    };
}

